import { globalStyle } from "./global-style"
import { layerStyles } from "./layer-styles"
import { resetStyle } from "./reset-style"
import { textStyles } from "./text-styles"

export const styles = {
  globalStyle,
  layerStyles,
  resetStyle,
  textStyles,
}
